import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { createGlobalStyle } from 'styled-components';
import WHAT_IFS_DICTIONARY from './WhatIfsComponentDictionary';
import { isNumeric } from '../../js/app/react/validators';
import WhatIfsShell from './WhatIfShell/WhatIfShellContainer';
import { LIFE, DISABILITY, LONG_TERM_CARE } from '../FinancialPlan/Insurance/InsuranceConstants';

const GliaGlobalStyle = createGlobalStyle`
  #salemove .sm-visitor-app {
    right: ${props => (props.whatIfsOpen ? '330px' : '30px')} !important;
  }

  .sm-engaged-right #salemove .sm-visitor-app {
    right: 0 !important;
  }
`;

class WhatIfsView extends Component {
  componentDidMount() {
    const { hasStickyNavbar } = this.props;
    if (!hasStickyNavbar) {
      window.addEventListener('scroll', this.onResize, true);
    }
  }

  componentDidUpdate(prevProps) {
    const { clientId, goalId, resetView, fpId, selectedInsuranceType, goalData } = this.props;
    const { DebtType } = goalData;

    if (
      fpId !== prevProps.fpId ||
      goalId !== prevProps.goalId ||
      clientId !== prevProps.clientId ||
      selectedInsuranceType !== prevProps.selectedInsuranceType ||
      DebtType !== prevProps.goalData.DebtType
    ) {
      resetView(clientId, goalId);
    }
  }

  componentWillUnmount() {
    const { hasStickyNavbar, resetModelPortfoliosGroups, clientId } = this.props;
    if (!hasStickyNavbar) {
      window.removeEventListener('scroll', this.onResize, true);
    }
    resetModelPortfoliosGroups(clientId);
  }

  render() {
    const {
      clientId,
      open,
      visible,
      currentView,
      hasShell,
      isEstatePlanning2,
      goalData: { GoalType },
    } = this.props;

    if (!isEstatePlanning2 && GoalType === 'estatePlanning') {
      return null;
    }

    if (!visible) {
      return null;
    }

    if (!open || !isNumeric(currentView) || !WHAT_IFS_DICTIONARY[currentView]) {
      return (
        <div className={`WhatIfs${open ? ' open' : ' closed'}`}>
          <GliaGlobalStyle whatIfsOpen={open} />
        </div>
      );
    }

    if (hasShell) {
      return (
        <div className={`WhatIfs${open ? ' open' : ' closed'}`}>
          <GliaGlobalStyle whatIfsOpen={open} />
          <WhatIfsShell clientId={clientId} />
        </div>
      );
    }

    const WhatIfView = WHAT_IFS_DICTIONARY[currentView];
    return (
      <div className={`WhatIfs${open ? ' open' : ' closed'}`}>
        <GliaGlobalStyle whatIfsOpen={open} />
        <WhatIfView clientId={clientId} />
      </div>
    );
  }
}

WhatIfsView.defaultProps = {
  visible: false,
  open: false,
  hasShell: false,
  currentView: null,
  fpId: null,
};

WhatIfsView.propTypes = {
  hasShell: PropTypes.bool,
  clientId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  open: PropTypes.bool,
  visible: PropTypes.bool,
  currentView: PropTypes.number,
  fpId: PropTypes.string,
  selectedInsuranceType: PropTypes.oneOf([LIFE, DISABILITY, LONG_TERM_CARE]).isRequired,
  goalId: PropTypes.string.isRequired,
  resetView: PropTypes.func.isRequired,
  hasStickyNavbar: PropTypes.bool.isRequired,
  goalData: PropTypes.shape({
    DebtType: PropTypes.number,
    GoalType: PropTypes.string,
  }).isRequired,
  resetModelPortfoliosGroups: PropTypes.func.isRequired,
  isEstatePlanning2: PropTypes.bool.isRequired,
};

export default WhatIfsView;
